import React from 'react';
import style from './style.module.scss';

interface WrapperProps {
  children: React.ReactNode;
}
export const Wrapper: React.FC<WrapperProps> = (props) => {
  return <div className={style.wrapper}>
    {props.children}
  </div>
}
